import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { displayCount } from "@utils/utils";

const SubTabsBar = ({ activeTab, tradeDirection, onChange, showAnalyticsTab, importerCount, exporterCount, actions }) => {
  const tabCount = tradeDirection === "import" ? importerCount : exporterCount;
  const productSubTabsList = [
    { key: "analytics", label: "Analytics", icon: "donut_small" },
    { key: "tariffs", label: "Tariffs", icon: "balance" },
    { key: "buyerSupplier", label: tradeDirection === "import" ? "Buyers List" : "Suppliers List", icon: "list_alt", count: tabCount },
    { key: "aiSummary", label: "AI Summary", iconUrl: `${CLOUDINARY_INTEL_BASE_URL}/v1761888982/Sanctions/sparkle_3_hv5h4n.svg` },
  ];

  return (
    <div className="tw-flex tw-items-center tw-gap-1 tw-border-b tw-border-gray-200 tw-pt-2">
      {productSubTabsList.map((tab) => {
        const isActive = activeTab === tab.key;
        if (!showAnalyticsTab && tab.key === "analytics") return null;
        return (
          <button key={tab.key} onClick={() => onChange(tab.key)} className={`tw-flex tw-bg-transparent tw-items-center tw-gap-1.5 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-border-b-2 tw--mb-[1px] tw-transition-colors ${isActive ? "tw-text-primary-purple-600 tw-border-primary-purple-500" : "tw-text-gray-600 tw-border-transparent hover:tw-text-gray-900"}`}>
            {tab.iconUrl ? <img src={tab.iconUrl} alt={tab.label} className="tw-w-[18px] tw-h-[18px]" /> : <span className="material-symbols-outlined">{tab.icon}</span>}
            <span>{tab.label}</span>
            {tab.count > 0 && <span className={`tw-text-xs tw-font-medium tw-px-1.5 tw-py-0.5 tw-rounded-full ${isActive ? "tw-bg-primary-purple-100 tw-text-primary-purple-700" : "tw-bg-gray-100 tw-text-gray-600"}`}>{displayCount(tab.count, 2)}</span>}
          </button>
        );
      })}
      {actions && <div className="tw-ml-auto tw-pb-1.5">{actions}</div>}
    </div>
  );
};

export default SubTabsBar;
